import React, { useState, useEffect, Suspense, useCallback, lazy, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  Tabs,
  Card,
  Breadcrumb,
  DropdownButton,
  Badge,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import TextField from '@mui/material/TextField';
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import './ProjectView.css';
import Popup from 'reactjs-popup';
// import 'reactjs-popup/dist/index.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import * as Icon from 'react-bootstrap-icons';
// import { threeDotsVertical } from 'react-bootstrap-icons';
import { useSelector, useDispatch } from "react-redux";
import { fetchRoomList, updateRoomOrder } from "../redux/viewRoomReducer";
import { fetchQuotationList } from "../redux/quotationReducer";
// import ClientPDF from "./ClientPDF";
// import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Triangle } from 'react-loader-spinner';
// import { renameRoomName } from "../redux/renameRoomReducer";
import ExportToExcel from "./ExportToExcel";
import { auth, firestore as db } from "../config/Config";
import { renameDesignName } from "../redux/renameDesignReducer";
import { duplicateDesigns } from "../redux/duplicationDesignReducer";
import ExportExcel from "./ExportExcel";
import axios from "axios";
import Sidebar from "./SidebarNav";
import {
  LayoutGrid,
  BedDouble,
  Utensils,
  ChefHat,
  Tv,
  Sparkles,
  Lamp,
  Sofa,
  DoorOpen,
  Box,
  Wrench,
  Diamond,
  Search,
  Plus,
  MoreVertical,
  Check,
  Disc,
  UserCheck,
  Edit3,
  Trash2,
  Copy,
  Eye,
  Pencil,
  FileText,
} from "lucide-react";
// import { asString } from "html2canvas/dist/types/css/types/color";

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Paper from '@mui/material/Paper';
import { fetchProjectList } from "../redux/projectReducer";
import Swal from "sweetalert2";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { updateQuotationPermission } from "../redux/QuotationPermission";
import ViewProfile from './ViewProfile';
import { fetchUserList } from '../redux/userReducer';
import { fetchKitchenThingsList } from '../redux/kitchenThingsReducer';
import { fetchLooseThingsList } from '../redux/looseFurnitureReducer';
import { fetchOtherWorksList } from '../redux/otherWorkReducer';
import { fetchBedroomList } from '../redux/bedroomReducer';
import { fetchFoyerThingsList } from '../redux/foyerReducer';
import { fetchLivingThingsList } from '../redux/livingRoomReducer';
import { fetchAccessoriesList } from '../redux/accessoriesReducer';


// ✅ Single helper — dispatches ALL location + database-dependent room data at once
// NOTE: `projectLocation` here must be the project's location string (e.g. "KKT" / "BLR"),
// NOT the react-router location object. Passing the router location object was the bug
// that caused these fetches to silently fail (see fetchUserData below).
const dispatchAllRoomData = (dispatch) => {
  // const args = { location: projectLocation, databaseId };
  dispatch(fetchKitchenThingsList());
  dispatch(fetchLooseThingsList());
  dispatch(fetchOtherWorksList());
  dispatch(fetchBedroomList());
  dispatch(fetchFoyerThingsList());
  dispatch(fetchLivingThingsList());
  dispatch(fetchAccessoriesList());
};




const LazyPDFDownloadButton = lazy(() => import('./PDFDownloadButton'))

function ProjectView() {
  const dispatch = useDispatch();
  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);

  const [currentPage, setCurrentPage] = useState(1);
  console.log("currentPage", currentPage);

  // Renamed from `location` to `routerLocation` to avoid shadowing/colliding with the
  const routerLocation = useLocation();
  const [dataOfClient, setDataOfClient] = useState(() => {
    if (routerLocation.state) {
      try {
        localStorage.setItem('current_project_client', JSON.stringify(routerLocation.state));
      } catch (e) {}
      return routerLocation.state;
    }
    try {
      const saved = localStorage.getItem('current_project_client');
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return {};
  });

  useEffect(() => {
    if (routerLocation.state && routerLocation.state.id !== dataOfClient?.id) {
      setDataOfClient(routerLocation.state);
      setDatac([]);
      try {
        localStorage.setItem('current_project_client', JSON.stringify(routerLocation.state));
      } catch (e) {}
    }
  }, [routerLocation.state, dataOfClient?.id]);

  console.log('dataof client', dataOfClient);
  const [SelectedPrice, setSelectedPrice] = useState(dataOfClient?.priceType || 'value');

  const [userList, setUserList] = useState([]);
  console.log("userList", userList);

  const [userdata, setUserdata] = useState({});

useEffect(() => {
  if (!dataOfClient?.id) return;
  const fetchUserData = async () => {
    try {
      const response = await fetch(
        `https://us-central1-fabdiz-quote.cloudfunctions.net/api/client/${dataOfClient.id}`
      );

      const data = await response.json();
      setUserdata(data);

      if (data.timestamp?._seconds) {
        const projectDate = new Date(data.timestamp._seconds * 1000);

        // Save project creation time
        window.localStorage.setItem(
          'projectCreationTime',
          projectDate.toISOString()
        );

        // ─── maxDiscountApproved ──────────────────────────────────────────────
        // If backend has maxDiscount → use it directly, no phase calculations
        if (data.maxDiscount !== undefined && data.maxDiscount !== null) {
          window.localStorage.setItem('maxDiscountApproved', data.maxDiscount);
        } else {
          // No backend value → clear stale entry so AddQuotation uses computed formula
          window.localStorage.removeItem('maxDiscountApproved');
        }
        // ─────────────────────────────────────────────────────────────────────
      }

      if (data.increment) {
        const projectIncrement = data.increment;
        window.localStorage.setItem('projectIncrement', projectIncrement);
      }

      // ─── projectDatabase ────────────────────────────────────────────────────
      // Resolve the database version for this project (defaults to '(default)')
      // const projectDatabase = data.database || '(default)';
      const projectDatabase = '(default)';
      window.localStorage.setItem('projectDatabase', projectDatabase);
      // ─────────────────────────────────────────────────────────────────────────

      dispatchAllRoomData(dispatch);

    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  fetchUserData();
}, [dataOfClient?.id, SelectedPrice]);

  console.log("userdata", userdata);




  const [lim, setLim] = useState(10);


  // to fetch the designers list 
  const fetchUsers = async () => {
    try {
      const response = await fetch('https://us-central1-fabdiz-quote.cloudfunctions.net/api/users');
      const data = await response.json();
      console.log("Fetched data:", data); // Log the full response to check its structure

      // Add this check to see if users are directly in data or under a different key
      if (!data || !Array.isArray(data)) {
        console.error("Data is not in the expected format:", data);
        return;
      }

      // Assuming the data is an array of users
      const formattedUsers = data.map(user => ({
        label: user.name,         // Make sure this matches the actual property name for user names
        userID: user.id,   // Make sure this matches the actual property name for user IDs
        userDesignation: user.designation,    // Make sure this matches the actual property name for user IDs
        userEmail: user.email    // Make sure this matches the actual property name for user IDs
      }));

      setUserList(formattedUsers); // Set the formatted data as options for Autocomplete
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  };


  const fileName = "Invoice.pdf";

  const navigation = useNavigate();

  // useSelector and dispatch

  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);

  useEffect(() => {
    const clientUID = dataOfClient?.id;
    if (!clientUID) return;
    dispatch(fetchQuotationList({ clientUID, roomName: 'projectRoom', page: currentPage, lim }));
  }, [currentPage, lim, dispatch, dataOfClient?.id]);

  const { viewData, viewLoader, viewError } = useSelector((state) => state.viewrooms);
  const { data, status, error } = useSelector((state) => state.viewquotes);
  const [refreshKey, setRefreshKey] = useState(0);
  const [deletedDesignIds, setDeletedDesignIds] = useState(() => new Set());

  const isDraftCard = (l) => {
    if (!l) return false;
    return !!(
      l.isDraft === true ||
      l.draftTag === 'Draft Saved Copy' ||
      l.isDraftCopy === true ||
      (l.ID && String(l.ID).startsWith('draft_')) ||
      (l.id && String(l.id).startsWith('draft_')) ||
      (l.roomTypeDesign && String(l.roomTypeDesign).toLowerCase().includes('draft'))
    );
  };

  // Merge any local draft cards stored in localStorage that are pending or newer than viewData
  const mergedViewData = useMemo(() => {
    const serverList = Array.isArray(viewData) ? viewData : [];
    const clientId = dataOfClient?.id;
    if (!clientId) return serverList;

    const localDrafts = [];
    try {
      for (let idx = 0; idx < localStorage.length; idx++) {
        const key = localStorage.key(idx);
        if (key && key.startsWith(`draft_card_${clientId}_`)) {
          const raw = localStorage.getItem(key);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && (parsed.id || parsed.ID)) {
              localDrafts.push(parsed);
            }
          }
        }
      }
    } catch (e) {
      console.error("Error reading drafts from localStorage:", e);
    }

    // Helper to resolve parent roomTypeName if missing
    const resolveRoomName = (item) => {
      if (item?.roomTypeName && String(item.roomTypeName).trim()) {
        return String(item.roomTypeName).trim();
      }
      const targetId = item?.draftOfId || (item?.id && String(item.id).startsWith('draft_') ? String(item.id).replace(/^draft_/, '') : (item?.ID && String(item.ID).startsWith('draft_') ? String(item.ID).replace(/^draft_/, '') : ''));
      if (targetId) {
        const parent = serverList.find(s => (s.id === targetId || s.ID === targetId) && s.roomTypeName && String(s.roomTypeName).trim());
        if (parent) return String(parent.roomTypeName).trim();
      }
      if (item?.roomTypeDesign) {
        const matchDesign = serverList.find(s => s.roomTypeName && String(s.roomTypeName).trim().toLowerCase() === String(item.roomTypeDesign).trim().toLowerCase());
        if (matchDesign) return String(matchDesign.roomTypeName).trim();
      }
      if (item?.roomType) {
        const matchType = serverList.find(s => s.roomTypeName && String(s.roomTypeName).trim().toLowerCase() === String(item.roomType).trim().toLowerCase());
        if (matchType) return String(matchType.roomTypeName).trim();
      }
      return '';
    };

    // Clone serverList objects so we never mutate frozen Redux state
    const list = serverList.map(item => {
      const resolved = resolveRoomName(item);
      return resolved ? { ...item, roomTypeName: resolved } : { ...item };
    });

    if (localDrafts.length > 0) {
      localDrafts.forEach((rawDraft) => {
        let draft = { ...rawDraft };
        const draftId = draft.id || draft.ID;
        if (!draftId) return;

        // Match existing item in list ONLY if it is the exact same draft document ID
        const existingDraftIdx = list.findIndex(item => {
          const itemId = item.id || item.ID;
          return itemId && itemId === draftId;
        });

        if (!draft.roomTypeName || !String(draft.roomTypeName).trim()) {
          const resolved = resolveRoomName(draft);
          if (resolved) {
            draft = { ...draft, roomTypeName: resolved };
          }
        }

        if (existingDraftIdx >= 0) {
          const serverUpdated = new Date(list[existingDraftIdx].updatedAt || 0).getTime();
          const localUpdated = new Date(draft.updatedAt || 0).getTime();
          if (localUpdated >= serverUpdated) {
            list[existingDraftIdx] = { ...list[existingDraftIdx], ...draft };
          }
        } else {
          list.push(draft);
        }
      });
    }

    if (deletedDesignIds.size > 0) {
      return list.filter(item => {
        const idStr = String(item?.id || item?.ID || '').trim();
        return !deletedDesignIds.has(idStr);
      });
    }

    return list;
  }, [viewData, dataOfClient?.id, refreshKey, deletedDesignIds]);

  // Background sync any local drafts to Firestore to guarantee cloud persistence
  useEffect(() => {
    const clientId = dataOfClient?.id;
    if (!clientId) return;
    try {
      for (let idx = 0; idx < localStorage.length; idx++) {
        const key = localStorage.key(idx);
        if (key && key.startsWith(`draft_card_${clientId}_`)) {
          const raw = localStorage.getItem(key);
          if (raw) {
            const draft = JSON.parse(raw);
            const draftId = draft.id || draft.ID;
            if (deletedDesignIds.has(String(draftId).trim())) continue;
            if (draftId && draft.roomTypeName && String(draft.roomTypeName).trim()) {
              db.collection("client").doc(clientId).collection("Rooms").doc(draftId).set(draft, { merge: true }).catch(() => {});
            }
          }
        }
      }
    } catch (e) {}
  }, [dataOfClient?.id, deletedDesignIds]);

  const result = useMemo(() => {
    if (!Array.isArray(mergedViewData)) return [];
    return mergedViewData.reduce((finalArray, current) => {
      const rawName = current?.roomTypeName;
      if (!rawName || typeof rawName !== 'string' || !rawName.trim()) {
        return finalArray;
      }
      const cleanName = rawName.trim();
      let obj = finalArray.find(item => item.roomTypeName && item.roomTypeName.trim().toLowerCase() === cleanName.toLowerCase());
      if (obj) {
        return finalArray;
      }
      return finalArray.concat([{ ...current, roomTypeName: cleanName }]);
    }, []);
  }, [mergedViewData]);


  useEffect(() => {
    if (!dataOfClient?.id) return;
    const viewData = {
      Id: dataOfClient.id,
    };
    dispatch(fetchRoomList(viewData));
  },
    [dispatch, dataOfClient?.id]);


  const userUID = localStorage.getItem('userUID');
  const priceState222 = useSelector((state) => state.price.value);




  const handleLogOut = () => {
    auth.signOut();
    window.location.reload();
  }

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <button
      type="button"
      ref={ref}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      style={{
        border: 'none',
        background: 'transparent',
        padding: '4px',
        borderRadius: '6px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748b',
        outline: 'none',
        boxShadow: 'none'
      }}
    >
      {children}
    </button>
  ));

  const getRoomIcon = (name = '', type = '') => {
    const s = `${name || ''} ${type || ''}`.toLowerCase();
    if (s.includes('kitchen')) return <ChefHat size={16} />;
    if (s.includes('bed') || s.includes('bedroom')) return <BedDouble size={16} />;
    if (s.includes('puja') || s.includes('pooja')) return <Sparkles size={16} />;
    if (s.includes('foyer')) return <DoorOpen size={16} />;
    if (s.includes('dining')) return <Utensils size={16} />;
    if (s.includes('tv') || s.includes('t.v')) return <Tv size={16} />;
    if (s.includes('living')) return <Sofa size={16} />;
    if (s.includes('walk') || s.includes('walkway')) return <Lamp size={16} />;
    if (s.includes('access')) return <LayoutGrid size={16} />;
    if (s.includes('shoe')) return <Box size={16} />;
    if (s.includes('crockery')) return <Disc size={16} />;
    if (s.includes('other')) return <Wrench size={16} />;
    return <LayoutGrid size={16} />;
  };

  // To add rooms for 
  const addRoom = () => {
    const cleanClientData = { ...dataOfClient };
    delete cleanClientData.restoreDraft;
    cleanClientData.roomType = "";
    cleanClientData.roomName = "";
    cleanClientData.restoreDraft = null;
    navigation('/projects/view-rooms/add-rooms', { state: cleanClientData });
  }

  // To add designs in same rooms
  const addDesign = (i) => {
    const cleanClientData = { ...dataOfClient };
    delete cleanClientData.restoreDraft;
    cleanClientData.roomType = i.roomType;
    cleanClientData.roomName = i.roomTypeName;
    cleanClientData.priceMode = i.priceMode;
    cleanClientData.restoreDraft = null;
    navigation('/projects/view-rooms/add-rooms', { state: cleanClientData });
  }
  // To edit designs in same rooms
  const editDesign = (i) => {
    dataOfClient['editData'] = i;
    navigation('/projects/view-rooms/edit-rooms', { state: dataOfClient });
  }

  // To view designs in same rooms
  const viewDesign = (i) => {
    dataOfClient['viewData'] = i;
    dataOfClient['allRoomData'] = mergedViewData;
    navigation('/projects/view-rooms/view-designs', { state: dataOfClient })
  }

  // rename modal
  const [renameOn, setRenameOn] = useState(false);
  const [renameID, setRenameID] = useState('');
  const [nameRoomTypeName, setNameRoomTypeName] = useState('');
  const [preNameRoomTypeName, setPreNameRoomTypeName] = useState('');
  const [statuesOn, setStatuesOn] = useState(false);


  const handleRenameCloseOn = () => {
    setRenameOn(false);
  };

  const renameModal = (i) => {
    setNameRoomTypeName(i.roomTypeName);
    setPreNameRoomTypeName(i.roomTypeName);
    setRenameID(i.ID);
    setRenameOn(true);
  };

  // to rename rooms name
  const handleRenameCom = async () => {
    const cid = dataOfClient.id;
    const id = renameID;

    console.log("cid", cid);
    console.log("preNameRoomTypeName", preNameRoomTypeName);
    console.log("nameRoomTypeName", nameRoomTypeName);
    console.log("id", id);

    try {
      const response = await axios.put('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateRoomName', {
        "cid": cid,
        "preRoomTypeName": preNameRoomTypeName,
        "roomTypeNewName": nameRoomTypeName,
        "state": "Rooms",
        "roomId": id
      });

      console.log(response.data.message);
      const viewData = {
        Id: dataOfClient.id,
      };

      dispatch(fetchRoomList(viewData));

    } catch (error) {
      console.log("Rename Room error", error.response ? error.response.data.message : 'Error updating room names');
    }

    setRenameOn(false);
  };


  // Design Rename Modal
  const [renameDesignModal, setRenameDesignModal] = useState(false);
  const [renameDesignID, setRenameDesignID] = useState('');
  const [selectedDesignItem, setSelectedDesignItem] = useState(null);
  const [newDesignTypeName, setNewDesignTypeName] = useState('');
  const [selectedName, setSelectedName] = useState(null);

  const handleRenameDesignCloseModal = () => {
    setRenameDesignModal(false);
  };

  const renameDesignModalFun = (i) => {
    setSelectedDesignItem(i);
    setNewDesignTypeName(i.roomTypeDesign || '');
    setRenameDesignID(i.ID || i.id || '');
    setRenameDesignModal(true);
  };

  const handleRenameDesignModal = async () => {
    const cid = dataOfClient?.id;
    if (!cid) return;
    const designId = renameDesignID || selectedDesignItem?.ID || selectedDesignItem?.id || '';
    const realId = designId ? String(designId).replace(/^draft_/, '') : '';

    try {
      // 1. Direct Firestore update
      if (designId) {
        await db.collection("client").doc(cid).collection("Rooms").doc(designId).set({ roomTypeDesign: newDesignTypeName }, { merge: true }).catch(() => {});
      }
      if (realId && realId !== designId) {
        await db.collection("client").doc(cid).collection("Rooms").doc(realId).set({ roomTypeDesign: newDesignTypeName }, { merge: true }).catch(() => {});
      }

      // 2. Update matching local drafts in localStorage
      for (let idx = 0; idx < localStorage.length; idx++) {
        const key = localStorage.key(idx);
        if (key && (key.startsWith(`draft_card_${cid}_`) || key.startsWith(`draft_room_${cid}_`))) {
          if ((designId && key.includes(designId)) || (realId && key.includes(realId))) {
            try {
              const raw = localStorage.getItem(key);
              if (raw) {
                const parsed = JSON.parse(raw);
                parsed.roomTypeDesign = newDesignTypeName;
                parsed.updatedAt = new Date().toISOString();
                localStorage.setItem(key, JSON.stringify(parsed));
              }
            } catch (e) {}
          }
        }
      }

      // 3. Notify cloud backend if realId exists
      if (realId && !String(designId).startsWith('draft_')) {
        await axios.put('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateDesignName', {
          "cid": cid,
          "designId": realId,
          "roomDesignNewName": newDesignTypeName,
        }).catch((e) => console.log("updateDesignName notice:", e.message));
      }

      setRefreshKey((k) => k + 1);
      dispatch(fetchRoomList({ Id: cid }));

    } catch (error) {
      console.error("Rename Design error", error);
    }

    setRenameDesignModal(false);
  };

  const duplicationDesign = async (l) => {
    const clientId = dataOfClient?.id;
    if (!clientId) return;

    const designData = {
      ...l,
      roomTypeDesign: `${l.roomTypeDesign || 'Design'} Copy`,
      ID: clientId,
    };

    try {
      await dispatch(duplicateDesigns(designData)).unwrap();
      setRefreshKey((k) => k + 1);
      dispatch(fetchRoomList({ Id: clientId }));
    } catch (error) {
      console.error('Error duplicating design:', error);
    }
  };

  const handleCardClick = (e) => {
    if (!e.target.closest(".dropdown-menu")) {
    }
  };


  // Delete Method for Rooms 
  const deleteRoomModal = async (roomName) => {
    const clientId = dataOfClient?.id;
    if (!clientId) return;
    const roomTypeName = encodeURIComponent(roomName.roomTypeName);

    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete the room "${roomName.roomTypeName}"? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (!confirm.isConfirmed) return;

    try {
      const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/deleteRoom/${clientId}/${roomTypeName}`;
      const response = await axios.delete(url);

      Swal.fire({
        title: 'Deleted!',
        text: response.data.message || 'Room has been successfully deleted.',
        icon: 'success',
        timer: 1200,
        showConfirmButton: false,
        toast: true,
        position: 'top-end'
      });

      setRefreshKey((k) => k + 1);
      dispatch(fetchRoomList({ Id: clientId }));
    } catch (error) {
      console.error("Error deleting room:", error);

      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || 'Something went wrong while deleting the room.',
        icon: 'error',
      });
    }
  };


  // Delete Method for Design Options (including Drafts)
  const deleteDocument = async (l) => {
    const clientId = dataOfClient?.id;
    if (!clientId) return;

    const isDraftItem = isDraftCard(l);
    const rawId = typeof l === 'string' ? l : (l?.id || l?.ID || '');
    const designId = String(rawId).trim();
    const realId = isDraftItem
      ? (l?.draftOfId || (designId.startsWith('draft_') ? designId.replace(/^draft_/, '') : ''))
      : designId;

    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: isDraftItem
        ? 'You are about to delete this draft copy. The original design option will NOT be affected.'
        : 'You are about to delete this design. This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (!confirmation.isConfirmed) return;

    // 1. Instantly update UI optimistically (dynamic immediate removal)
    setDeletedDesignIds((prev) => {
      const next = new Set(prev);
      if (designId) next.add(designId);
      if (isDraftItem && realId) next.add(`draft_${realId}`);
      if (!isDraftItem && realId) {
        next.add(realId);
        next.add(`draft_${realId}`);
      }
      return next;
    });

    try {
      // 2. Purge matching drafts from LocalStorage
      if (isDraftItem) {
        // ONLY remove this specific draft from localStorage
        localStorage.removeItem(`draft_card_${clientId}_${designId}`);
        if (realId) {
          localStorage.removeItem(`draft_card_${clientId}_draft_${realId}`);
        }
      } else {
        // Removing a real design: purge both the real design and its draft
        localStorage.removeItem(`draft_card_${clientId}_${realId}`);
        localStorage.removeItem(`draft_card_${clientId}_draft_${realId}`);
        for (let idx = localStorage.length - 1; idx >= 0; idx--) {
          const key = localStorage.key(idx);
          if (key && key.startsWith(`draft_card_${clientId}_`) && (key.includes(realId) || key.includes(designId))) {
            localStorage.removeItem(key);
          }
        }
      }

      // 3. Direct Firestore deletion
      const deletePromises = [];
      if (isDraftItem) {
        // CRITICAL: When deleting a draft, ONLY delete the draft document! NEVER touch realId!
        if (designId) {
          deletePromises.push(db.collection("client").doc(clientId).collection("Rooms").doc(designId).delete().catch(() => {}));
        }
        if (realId) {
          deletePromises.push(db.collection("client").doc(clientId).collection("Rooms").doc(`draft_${realId}`).delete().catch(() => {}));
        }
      } else {
        // When deleting a real design: delete the real document AND any draft of it
        if (realId) {
          deletePromises.push(db.collection("client").doc(clientId).collection("Rooms").doc(realId).delete().catch(() => {}));
          deletePromises.push(db.collection("client").doc(clientId).collection("Rooms").doc(`draft_${realId}`).delete().catch(() => {}));
        }
      }

      await Promise.all(deletePromises);

      // 4. Notify backend cloud function ONLY if deleting a real non-draft item
      if (!isDraftItem && realId) {
        axios.delete(
          `https://us-central1-fabdiz-quote.cloudfunctions.net/api/deleteDesign/${clientId}/${realId}`
        ).catch((e) => console.log("Background API delete notice:", e.message));
      }

      Swal.fire({
        title: 'Deleted!',
        text: isDraftItem ? 'Draft copy has been deleted.' : 'Design has been deleted.',
        icon: 'success',
        timer: 1000,
        showConfirmButton: false,
        toast: true,
        position: 'top-end'
      });

      setRefreshKey((k) => k + 1);
      dispatch(fetchRoomList({ Id: clientId }));
    } catch (error) {
      console.error("Delete error:", error);
      // Rollback optimistic removal on error
      setDeletedDesignIds((prev) => {
        const next = new Set(prev);
        if (designId) next.delete(designId);
        return next;
      });

      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || 'Something went wrong while deleting.',
        icon: 'error',
      });
    }
  };


  const assignToDataDeepCopy = structuredClone(data.quotes);

  console.log('assignToDataDeepCopy', assignToDataDeepCopy);


  const [assignedQuotiation, setAssignedQuotiation] = useState(null);
  const [description, setDescription] = useState('');
  console.log("assignedQuotiation", assignedQuotiation);

  const handleChange = (value) => {
    console.log("selectedRoom", value);
    setAssignedQuotiation(value);
  };


  // assigned project to 
  const [assignLoader, setAssignLoader] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleAssignProject = async () => {
    if (!selectedName || !assignedQuotiation) {
      Swal.fire({
        icon: "warning",
        title: "Missing Data",
        text: "Please select user and quotation",
      });
      return;
    }

    setAssignLoader(true);
    setProgress(0);

    // Fake progress animation
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + 10;
      });
    }, 200);

    const newClientData = {
      ID: selectedName.userID,
      cemail: assignedQuotiation.clientDetails.cemail || "",
      city: assignedQuotiation.clientDetails.city || "",
      cname: assignedQuotiation.clientDetails.cname || "",
      cphone: assignedQuotiation.clientDetails.cphone || "",
      assigner: assignedQuotiation.clientDetails.createdBy || "",
      createdBy: selectedName.label || "",
      date: assignedQuotiation.clientDetails.date || "",
      increment: assignedQuotiation.clientDetails.increment || "",
      pname: assignedQuotiation.clientDetails.pname || "",
      price: assignedQuotiation.clientDetails.priceType || "",
      state: assignedQuotiation.clientDetails.state || "",
      status: "Ongoing",
      timestamp: new Date(),
    };

    const assigneeToId = {
      ID: selectedName.userID,
    };

    const assignedProjectData = assignedQuotiation;

    try {
      const response = await fetch(
        `https://us-central1-fabdiz-quote.cloudfunctions.net/api/addClientCompletionDetails`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            newClientData,
            assigneeToId,
            assignedQuotiation
          }),
        }
      );

      const data = await response.json();

      clearInterval(interval);
      setProgress(100);

      setTimeout(() => {
        setAssignLoader(false);
        setProgress(0);
      }, 500);

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: data.message || "Client assigned successfully",
          confirmButtonColor: "#3085d6",
          timer: 2000,
          showConfirmButton: false,
        });

        dispatch(fetchProjectList({ userUID, page: currentPage, lim }));
        setOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message || "An error occurred",
          confirmButtonColor: "#d33",
        });
      }
    } catch (err) {
      clearInterval(interval);

      setAssignLoader(false);
      setProgress(0);

      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: "Failed to update client status",
        confirmButtonColor: "#d33",
      });
    }
  };


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    fetchUsers()
  };

  const handleClose = () => {
    setOpen(false);
  };


  const priceState = useSelector((state) => state.price.value);
  const [newPrice, setNewPrice] = useState(dataOfClient?.priceType || 'value');
  const [openDoor, setOpenDoor] = useState(false);

  const [increment, setIncrement] = useState(0);


  // Function to modify data before copying
  const { kitchenThingsData } = useSelector((state) => state.kitchenThings);
  const { bedroomThingsData } = useSelector((state) => state.bedroomThings);
  const { foyerThingsData } = useSelector((state) => state.foyerThings);
  const { livingThingsData } = useSelector((state) => state.livingThings);
  const { otherWorkThingsData } = useSelector((state) => state.OtherWorkThings);
  const { looseThingsData } = useSelector((state) => state.looseThings);
  const { accessoriesThingsData } = useSelector((state) => state.accessories);


  const changeThePrice = async () => {
    const pricemode = SelectedPrice;
    const newIncrement = increment;
    const quotations = dataOfClient?.id;
    var DataOfTheClient = dataOfClient;

    if (!quotations) {
      console.error("Error: Client ID (quotations) is undefined.");
      return;
    }

    Swal.fire({
      title: 'Updating Prices...',
      html: 'Please wait while we update the prices.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const snapshot = await db.collection("client").doc(quotations).collection("Rooms").get();

      const updateDataofClient = {
        ...DataOfTheClient,
        priceType: pricemode,
        increment: newIncrement
      };

      try {
        await db.collection("client").doc(quotations).set(updateDataofClient);
        console.log("Client data updated successfully:", updateDataofClient);
      } catch (error) {
        console.error("Error updating client data:", error.message);
      }

      const promises = snapshot.docs.map(async (doc) => {
        const docData = doc.data();
        const updatedData = modifyPrice(docData, newIncrement, pricemode);

        if (!updatedData || typeof updatedData !== 'object' || Array.isArray(updatedData)) {
          console.error("Invalid data format for Firestore update:", updatedData);
          return;
        }

        await db.collection("client").doc(quotations).collection("Rooms").doc(doc.id).update(updatedData);
        console.log("Updated document:", doc.id, updatedData);
      });

      await Promise.all(promises);

      const clientRef = db.collection("client").doc(quotations);
      const freshClientSnapshot = await clientRef.get();
      const freshClientData = freshClientSnapshot.data();
      setDataOfClient(freshClientData);

      Swal.fire({
        icon: 'success',
        title: 'Prices Updated!',
        text: 'All rooms have been updated successfully.',
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Error updating price:", error.message);
      Swal.close();
    }

    setSelectedPrice(SelectedPrice);
    setOpenDoor(false);
  };


  // ✅ FIXED modifyPrice FUNCTION
  const modifyPrice = (oldData, newIncrement, pricemode) => {
    if (!oldData || typeof oldData !== 'object') {
      console.warn("modifyPrice received invalid data:", oldData);
      return {};
    }

    const incrementPercentage = newIncrement / 100;
    let grandTotalPrice = 0;

    const kitchendata = JSON.parse(JSON.stringify(kitchenThingsData));
    const bedroomdata = JSON.parse(JSON.stringify(bedroomThingsData || []));
    const foyerdata = JSON.parse(JSON.stringify(foyerThingsData || []));
    const livingdata = JSON.parse(JSON.stringify(livingThingsData || []));
    const otherWorkdata = JSON.parse(JSON.stringify(otherWorkThingsData || []));
    const accessoriesdata = JSON.parse(JSON.stringify(accessoriesThingsData || []));


    const findMaterialValue = (roomType, itemName, itemLabel, defaultValue) => {
      const roomDatasets = {
        Kitchen: kitchendata,
        Bedroom: bedroomdata,
        Foyer: foyerdata,
        "Living Room": livingdata,
        "Other Works": otherWorkdata,
        Accessories: accessoriesdata
      }[roomType];
      const matchedItem = roomDatasets.find(match => match.name == itemName);
      console.log("matchedItem", matchedItem);

      if (!matchedItem) {
        console.warn("Material not found:", itemName);
        return defaultValue;
      }

      const selectedMaterial = matchedItem.material.find(labelObject => labelObject.label === itemLabel);
      console.warn("selectedMaterial not found:", roomType, itemName, itemLabel, selectedMaterial);
      return selectedMaterial?.[pricemode] ?? defaultValue;
    };

    let totalPrice = 0;

    if (Array.isArray(oldData.title)) {
      oldData.title = oldData.title.map(item => {
        const value22 = findMaterialValue(oldData.roomType, item.name, item.label, item.value) || 0;

        let price = 0;
        let multiplier = item.type === 'woodwork' ? 1 + incrementPercentage : 1;

        if (item.area > 0) {
          price = value22 * item.area;
        } else if (item.value2 > 0) {
          price = value22 * item.width * item.height * item.qnty;
          if (item.value2 > 0) {
            price += parseFloat(item.value2);
            item.valueIncresed2 = Math.round(item.value2 * multiplier);
          }
        } else if (item.width === 0 && item.height === 0 && item.qnty > 0) {
          price = value22 * item.qnty;
        } else if (item.width > 0 && item.height > 0) {
          price = value22 * item.height * item.width;
        } else if (item.rft > 0) {
          price = value22 * item.rft;
        } else if (item.qnty > 0) {
          price = value22 * item.qnty;
        }
        if (item.painting > 0) {
          price = value22 * item.painting;
        }

        return {
          ...item,
          value: value22,
          valueIncreased: Math.round(value22 * multiplier),
          price: Math.round(price * multiplier)
        };
      });

      totalPrice = oldData.title.reduce((sum, item) => sum + (item.price || 0), 0);
    }

    return {
      ...oldData,
      roomTypePrice: totalPrice,
      priceMode: pricemode
    };
  };


  ///////////////////////////////////////////////////////////////////////////////

  const [datac, setDatac] = useState(result);
  const [activeIndex, setActiveIndex] = useState(0);
  const [roomSearch, setRoomSearch] = useState("");
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [roomDrafts, setRoomDrafts] = useState([]);
  const [showDraftListDropdown, setShowDraftListDropdown] = useState(false);

  // Real-time listener for Room Creation Drafts
  useEffect(() => {
    const clientId = dataOfClient?.id;
    if (!clientId) return;

    // Load initial cached drafts from LocalStorage
    const localDrafts = [];
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(`room_creation_draft_${clientId}_`)) {
          const raw = localStorage.getItem(k);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (
              parsed &&
              (((parsed.roomType && parsed.roomType !== 'Select a Room' && parsed.roomType.trim() !== '') ||
                (parsed.roomTypeName && parsed.roomTypeName.trim() !== '') ||
                (parsed.roomTypeDesign && parsed.roomTypeDesign.trim() !== '')) ||
                (parsed.kitchenFormData && parsed.kitchenFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.bedroomFormData && parsed.bedroomFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.foyerFormData && parsed.foyerFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.livingFormData && parsed.livingFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.otherFormData && parsed.otherFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.looseFormData && parsed.looseFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.accessoriesFormData && parsed.accessoriesFormData.some((x) => x.label || x.price > 0)) ||
                (parsed.materialFields && parsed.materialFields.some((x) => x.label || x.value > 0)))
            ) {
              localDrafts.push(parsed);
            }
          }
        }
      }
    } catch (e) {}

    if (localDrafts.length > 0) {
      setRoomDrafts(localDrafts);
    }

    // Real-time Firestore sync
    const unsubscribe = db
      .collection("client")
      .doc(clientId)
      .collection("RoomCreationDrafts")
      .onSnapshot(
        (snapshot) => {
          const dbDrafts = [];
          snapshot.forEach((doc) => {
            dbDrafts.push({ id: doc.id, ...doc.data() });
          });

          // Merge dbDrafts and localDrafts ensuring newest version by timestamp
          const draftMap = new Map();
          dbDrafts.forEach((d) => {
            if (d && d.id) draftMap.set(d.id, d);
          });
          localDrafts.forEach((ld) => {
            if (ld && ld.id) {
              const existing = draftMap.get(ld.id);
              if (!existing || ((ld.timestamp || 0) >= (existing.timestamp || 0))) {
                draftMap.set(ld.id, ld);
              }
              // Background sync to Firestore if not yet present in Firestore
              if (!existing) {
                db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(ld.id).set(ld, { merge: true }).catch(() => {});
              }
            }
          });

          setRoomDrafts(Array.from(draftMap.values()));
        },
        (err) => {
          console.error("Room drafts listener error:", err);
        }
      );

    return () => unsubscribe();
  }, [dataOfClient?.id, refreshKey]);

  const handleRestoreRoomDraft = (dr) => {
    setShowDraftListDropdown(false);
    navigation('/projects/view-rooms/add-rooms', {
      state: {
        ...dataOfClient,
        roomType: dr.roomType || '',
        roomName: dr.roomTypeName || '',
        priceMode: dr.priceGen || dataOfClient?.priceType || 'value',
        restoreDraft: dr,
      }
    });
  };

  const handleDeleteRoomDraft = async (dr) => {
    const clientId = dataOfClient?.id;
    if (!clientId || !dr?.id) return;

    const result = await Swal.fire({
      title: "Discard Draft?",
      text: `Are you sure you want to discard the draft for "${dr.roomTypeName || dr.roomType || 'this room'}"? All unsaved draft data will be removed.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Yes, Discard Draft",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // 1. Instant optimistic state update & close dropdown
      setShowDraftListDropdown(false);
      setRoomDrafts(prev => prev.filter(item => item.id !== dr.id));

      // 2. Remove from LocalStorage
      localStorage.removeItem(`room_creation_draft_${clientId}_${dr.id}`);
      localStorage.removeItem(`room_creation_draft_${clientId}_default`);
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const k = localStorage.key(i);
        if (k && k.startsWith(`room_creation_draft_${clientId}_`) && (k.includes(dr.id) || k.includes('default'))) {
          localStorage.removeItem(k);
        }
      }

      // 3. Background delete from Firestore without blocking UI
      db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(dr.id).delete().catch(() => {});

      Swal.fire({
        icon: "success",
        title: "Draft Discarded",
        timer: 800,
        showConfirmButton: false,
      });
    } catch (e) {
      console.error("Error deleting room draft:", e);
    }
  };

  const handleDeleteAllRoomDrafts = async () => {
    const clientId = dataOfClient?.id;
    if (!clientId || roomDrafts.length === 0) return;

    const result = await Swal.fire({
      title: "Discard All Drafts?",
      text: `Are you sure you want to discard all ${roomDrafts.length} unsaved room drafts? This cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Yes, Discard All",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      for (const dr of roomDrafts) {
        localStorage.removeItem(`room_creation_draft_${clientId}_${dr.id}`);
        await db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(dr.id).delete().catch(() => {});
      }
      localStorage.removeItem(`room_creation_draft_${clientId}_default`);
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const k = localStorage.key(i);
        if (k && k.startsWith(`room_creation_draft_${clientId}_`)) {
          localStorage.removeItem(k);
        }
      }

      setRoomDrafts([]);
      setShowDraftListDropdown(false);

      Swal.fire({
        icon: "success",
        title: "All Drafts Discarded",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (e) {
      console.error("Error deleting all room drafts:", e);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.crm-custom-dropdown-container')) {
        setActiveDropdownId(null);
        setShowDraftListDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (!Array.isArray(result)) return;
    setDatac((prev) => {
      if (!prev || prev.length === 0) return result;
      const prevKeys = prev.map(r => r.roomTypeName || '').join('|');
      const newKeys = result.map(r => r.roomTypeName || '').join('|');
      if (prevKeys !== newKeys) {
        return result;
      }
      return prev;
    });
  }, [result]);

  const displayedRooms = useMemo(() => {
    const list = Array.isArray(datac) ? datac : (Array.isArray(result) ? result : []);
    if (!roomSearch.trim()) return list;
    return list.filter(r => (r.roomTypeName || r.roomType || '').toLowerCase().includes(roomSearch.toLowerCase()));
  }, [datac, result, roomSearch]);

  const activeRoom = useMemo(() => {
    if (!result || result.length === 0) return null;
    if (activeIndex >= 0 && activeIndex < result.length) {
      return result[activeIndex];
    }
    return result[0];
  }, [result, activeIndex]);

  const activeRoomDesignOptions = useMemo(() => {
    if (!activeRoom || !activeRoom.roomTypeName) return [];
    const targetRoomName = String(activeRoom.roomTypeName).trim().toLowerCase();
    const rawOptions = mergedViewData.filter(
      (l) => l.roomTypeName && String(l.roomTypeName).trim().toLowerCase() === targetRoomName
    );

    const resultList = [];
    const seenMap = new Map();

    for (const item of rawOptions) {
      const itemId = String(item.id || item.ID || '').trim();
      const isDraft = isDraftCard(item);
      const rawDesignName = String(item.roomTypeDesign || '')
        .replace(/\s*\(Draft Copy\)/gi, '')
        .replace(/\s*\(Draft\)/gi, '')
        .trim().toLowerCase();

      // Unique slot key per design option name:
      // Non-draft items with the same roomTypeDesign ("this demi") collapse into 1 card.
      // Draft items ("this demi (Draft Copy)") collapse into 1 draft card if present.
      const slotKey = isDraft
        ? `draft_${rawDesignName || itemId}`
        : `orig_${rawDesignName || itemId || resultList.length}`;

      if (seenMap.has(slotKey)) {
        const existingIdx = seenMap.get(slotKey);
        const existingItem = resultList[existingIdx];
        const itemUpdated = new Date(item.updatedAt || 0).getTime();
        const existingUpdated = new Date(existingItem.updatedAt || 0).getTime();

        if (itemUpdated >= existingUpdated || (item.title?.length || 0) >= (existingItem.title?.length || 0)) {
          resultList[existingIdx] = item;
        }
      } else {
        seenMap.set(slotKey, resultList.length);
        resultList.push(item);
      }
    }

    return resultList;
  }, [mergedViewData, activeRoom]);

  const handleDragEnd = (resultg) => {
    const { source, destination } = resultg;
    const clientId = dataOfClient.id;

    if (!destination || source.index === destination.index) return;

    const reordered = Array.from(datac && datac.length > 0 ? datac : result);
    const [moved] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, moved);

    setDatac(reordered);
  };

  const [selectedOptions, setSelectedOptions] = useState({});
  const loading = useSelector((state) => state.quotationPermission.loading);
  const [selectedOptionLoader, setSelectedOptionLoader] = useState({})
  console.log("rowId, key, value", selectedOptions);


  const handleCheckboxChange = async (rowId, key, value) => {
    console.log(rowId, key, value);

    setSelectedOptionLoader((prev) => ({ ...prev, [rowId]: true }));
    const toggledValue = !value;

    let updatedRowPermissions = {
      ...(selectedOptions[rowId] || {}),
    };

    if (key === "height" || key === "width") {
      updatedRowPermissions = {
        ...updatedRowPermissions,
        height: toggledValue,
        width: toggledValue,
      };
    } else {
      updatedRowPermissions = {
        ...updatedRowPermissions,
        [key]: toggledValue,
      };
    }

    setSelectedOptions((prev) => ({
      ...prev,
      [rowId]: updatedRowPermissions,
    }));

    const permissionData1 = data.quotes.map((quote) => {
      if (quote.ID === rowId) {
        return {
          ...quote,
          quotationpermission: {
            ...quote.quotationpermission,
            ...updatedRowPermissions,
          },
        };
      }
      return quote;
    });

    const permissionData = permissionData1.find((quote) => quote.ID === rowId);

    console.log("mainData", permissionData);

    try {
      await dispatch(updateQuotationPermission(permissionData)).unwrap();
    } catch (err) {
      console.error("Update failed", err);
    } finally {
      setSelectedOptionLoader((prev) => ({ ...prev, [rowId]: false }));
    }
  };


  return (
    <Container fluid>
      <Row className='m-0'>
        <Col sm={1} >

          <Modal show={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header onClick={() => setOpenDoor(false)} closeButton>
              <Modal.Title id="contained-modal-title-vcenter">Price Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={(e) => {
                e.preventDefault();
                changeThePrice();
              }}>
                <div className="container">
                  <p>Price Change To</p>
                  <select
                    aria-label="Room Type Select"
                    value={SelectedPrice}
                    onChange={(e) => setSelectedPrice(e.currentTarget.value)}
                  >
                    <option value=""></option>
                    <option value="oldvalue">Old Price</option>
                    <option value="value">New Price</option>
                  </select>
                </div>
                <div className="container">
                  <p>Increment</p>
                  <input
                    type="number"
                    placeholder="Increment"
                    value={increment}
                    onChange={(e) => setIncrement(e.target.value)}
                  />
                </div>
                <Modal.Footer>
                  <Button type="submit">Change</Button>
                  <Button onClick={() => setOpenDoor(false)}>Close</Button>
                </Modal.Footer>
              </form>
            </Modal.Body>
          </Modal>

          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>
          <Row >
            <Col>
              <Col sm={10}  >
              </Col>
              <Col  >
              </Col>
              <Col sm={2} >
              </Col>
            </Col>
          </Row>
          <Row className="p-4">
            <Row>
              <hr />
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center'
              }}>
                <Breadcrumb >
                  <Breadcrumb.Item
                    className="breadcrumb-item-animate"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      transition: "all 0.3s ease",
                      marginLeft: "20px",
                      textDecoration: "none",
                      backgroundColor: '#ea6e2b',
                      borderRadius: "0 20px 20px 0",
                      height: 30,
                      width: 120,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                      ":hover": {
                        backgroundColor: "#FFA500",
                        transform: "scale(1.1)",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                      }
                    }}
                    href="/projects"
                  >
                    Projects
                  </Breadcrumb.Item>

                  <Breadcrumb.Item
                    style={{
                      height: 30,
                      width: 'auto',
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "white",
                      textTransform: "uppercase",
                      borderRadius: "0 20px 20px 0",
                      backgroundColor: '#ea6e2b',
                      marginLeft: "10px",
                      padding: '0 5px 0 5px',
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    active
                  >
                    {dataOfClient?.cname || ''}
                  </Breadcrumb.Item>

                </Breadcrumb>
                <Button style={{ backgroundColor: 'green', marginBottom: '16px' }} onClick={handleClickOpen} >Assign To</Button>
              </div>
              <hr />

            </Row>

            {viewLoader ? (
              <center>
                <Triangle
                  height="120"
                  color="#ff5100"
                  ariaLabel="triangle-loading"
                  radius="1"
                  wrapperStyle={{ position: "absolute", top: "50%", left: "50%" }}
                  wrapperClass=""
                  visible={true}
                />
              </center>
            ) : mergedViewData ? (
              <div style={{ width: "100%" }}>
                {/* ── CARD 1: TEST IMPORT ROOMS / ROOMS LIST ── */}
                <div
                  className="project-page-card"
                  style={{
                    position: "relative",
                    zIndex: activeDropdownId?.startsWith("room_") ? 100 : 10,
                    overflow: "visible",
                  }}
                >
                  {/* Header */}
                  <div className="project-section-header">
                    <div className="project-section-title-wrap">
                      <div className="project-section-icon-box">
                        <LayoutGrid size={22} />
                      </div>
                      <div>
                        <h2 className="project-section-title">
                          {dataOfClient?.pname || dataOfClient?.cname || "Rooms"}
                        </h2>
                        <p className="project-section-subtitle">
                          Manage rooms and designs
                        </p>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                      {/* Search Bar */}
                      <div className="room-search-input-wrap">
                        <Search
                          size={16}
                          style={{
                            position: "absolute",
                            left: "12px",
                            color: "#94a3b8",
                            pointerEvents: "none",
                          }}
                        />
                        <input
                          type="text"
                          placeholder="Search rooms..."
                          value={roomSearch}
                          onChange={(e) => setRoomSearch(e.target.value)}
                          className="room-search-input"
                        />
                      </div>

                      {/* Draft & Add Room Action Buttons */}
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {roomDrafts.length > 0 && (
                          <div className="crm-custom-dropdown-container" style={{ position: "relative" }}>
                            <button
                              type="button"
                              className="btn-outline-orange"
                              style={{
                                borderColor: "#ea580c",
                                color: "#ea580c",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "8px 16px",
                                borderRadius: "10px",
                                background: "#fff7ed",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setShowDraftListDropdown((prev) => !prev);
                              }}
                            >
                              <FileText size={15} />
                              Draft ({roomDrafts.length})
                            </button>

                            {/* Dropdown for saved drafts */}
                            {showDraftListDropdown && (
                              <div
                                className="crm-custom-dropdown-menu"
                                style={{
                                  width: "320px",
                                  top: "calc(100% + 6px)",
                                  right: 0,
                                  padding: "10px",
                                  zIndex: 999999,
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "4px 6px 8px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                    }}
                                  >
                                    Saved Room Drafts ({roomDrafts.length})
                                  </span>
                                  {roomDrafts.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={handleDeleteAllRoomDrafts}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        color: "#ef4444",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        padding: "2px 6px",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      Discard All
                                    </button>
                                  )}
                                </div>
                                <div className="crm-dropdown-divider" style={{ margin: "4px 0 8px" }} />
                                <div style={{ maxHeight: "260px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "6px" }}>
                                  {roomDrafts.map((dr, dIdx) => (
                                    <div
                                      key={dr.id || dIdx}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "9px 10px",
                                        borderRadius: "8px",
                                        backgroundColor: "#f8fafc",
                                        border: "1px solid #e2e8f0",
                                        gap: "8px",
                                      }}
                                    >
                                      <div
                                        style={{ flex: 1, minWidth: 0, cursor: "pointer" }}
                                        onClick={() => handleRestoreRoomDraft(dr)}
                                      >
                                        <div
                                          style={{
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            color: "#1e293b",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {dr.roomTypeName || dr.roomType || "Untitled Room"}
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
                                          <span style={{ fontSize: "11px", color: "#ea580c", fontWeight: "600" }}>
                                            {dr.roomType || "Room"}
                                          </span>
                                          {dr.roomTypeDesign && (
                                            <span style={{ fontSize: "11px", color: "#64748b" }}>
                                              • {dr.roomTypeDesign}
                                            </span>
                                          )}
                                          {dr.roomTypePrice > 0 && (
                                            <span style={{ fontSize: "11px", color: "#16a34a", fontWeight: "600", marginLeft: "auto" }}>
                                              Rs. {dr.roomTypePrice}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <button
                                          type="button"
                                          onClick={() => handleRestoreRoomDraft(dr)}
                                          style={{
                                            background: "#ea580c",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "4px 8px",
                                            fontSize: "11.5px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                          }}
                                          title="Restore Draft"
                                        >
                                          Open
                                        </button>
                                        <button
                                          type="button"
                                          style={{
                                            background: "#fee2e2",
                                            border: "1px solid #fca5a5",
                                            color: "#dc2626",
                                            padding: "4px 6px",
                                            cursor: "pointer",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                          title="Discard Draft"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteRoomDraft(dr);
                                          }}
                                        >
                                          <Trash2 size={13} />
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Add Room Button */}
                        <button
                          type="button"
                          className="btn-primary-orange"
                          onClick={() => addRoom()}
                        >
                          <Plus size={16} strokeWidth={2.5} />
                          Add room
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Rooms Grid with Drag & Drop */}
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="ROOT" direction="horizontal" type="group">
                      {(provided) => (
                        <div
                          className="rooms-grid-container"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={{ overflow: "visible" }}
                        >
                          {displayedRooms.length > 0 ? (
                            displayedRooms.map((i, ind) => {
                              const originalIdx = result.findIndex(
                                (r) => (r.roomTypeName && i.roomTypeName && r.roomTypeName.trim().toLowerCase() === i.roomTypeName.trim().toLowerCase()) || ((r.id || r.ID) === (i.id || i.ID))
                              );
                              const isSelected = Boolean(activeRoom?.roomTypeName && i?.roomTypeName && activeRoom.roomTypeName.trim().toLowerCase() === i.roomTypeName.trim().toLowerCase());
                              const isRoomDropdownOpen = activeDropdownId === `room_${ind}`;

                              return (
                                <Draggable
                                  draggableId={String(i.id || i.ID || ind)}
                                  index={ind}
                                  key={String(i.id || i.ID || ind)}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className={`room-item-pill ${isSelected ? "active" : ""} ${isRoomDropdownOpen ? "has-open-dropdown" : ""}`}
                                      style={{
                                        ...provided.draggableProps.style,
                                        position: "relative",
                                        zIndex: isRoomDropdownOpen ? 99999 : 1,
                                        overflow: "visible",
                                      }}
                                      onClick={() => setActiveIndex(originalIdx >= 0 ? originalIdx : ind)}
                                    >
                                      <div style={{ display: "flex", alignItems: "center", minWidth: 0, flex: 1 }}>
                                        <div className="room-pill-icon">
                                          {getRoomIcon(i.roomTypeName, i.roomType)}
                                        </div>
                                        <span className="room-pill-title" title={i.roomTypeName}>
                                          {i.roomTypeName}
                                        </span>
                                      </div>

                                      <div style={{ display: "flex", alignItems: "center", gap: "6px", flexShrink: 0 }}>
                                        {isSelected && (
                                          <div className="room-active-check-badge">
                                            <Check size={12} strokeWidth={3} />
                                          </div>
                                        )}

                                        {dataOfClient.from !== 'sent' && (
                                          <div className="crm-custom-dropdown-container">
                                            <button
                                              type="button"
                                              className={`crm-dots-btn ${activeDropdownId === `room_${ind}` ? "is-active" : ""}`}
                                              title="Options"
                                              onMouseDown={(e) => e.stopPropagation()}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setActiveDropdownId(prev => prev === `room_${ind}` ? null : `room_${ind}`);
                                              }}
                                            >
                                              <MoreVertical size={16} />
                                            </button>

                                            {activeDropdownId === `room_${ind}` && (
                                              <div
                                                className="crm-custom-dropdown-menu"
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                <button
                                                  type="button"
                                                  className="crm-dropdown-item"
                                                  onClick={() => {
                                                    setActiveDropdownId(null);
                                                    renameModal(i);
                                                  }}
                                                >
                                                  <Edit3 size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                                  Rename Room
                                                </button>
                                                <button
                                                  type="button"
                                                  className="crm-dropdown-item"
                                                  onClick={() => {
                                                    setActiveDropdownId(null);
                                                    addDesign(i);
                                                  }}
                                                >
                                                  <Plus size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                                  Add Design Option
                                                </button>
                                                <div className="crm-dropdown-divider" />
                                                <button
                                                  type="button"
                                                  className="crm-dropdown-item text-danger"
                                                  onClick={() => {
                                                    setActiveDropdownId(null);
                                                    deleteRoomModal(i);
                                                  }}
                                                >
                                                  <Trash2 size={14} style={{ marginRight: "8px", color: "#ef4444" }} />
                                                  Delete Room
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })
                          ) : (
                            <div style={{ padding: "16px", color: "#94a3b8", fontSize: "14px", gridColumn: "1 / -1" }}>
                              No rooms found
                            </div>
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>

                {/* ── CARD 2: DESIGN OPTIONS FOR ACTIVE ROOM ── */}
                {activeRoom && (
                  <div
                    className="project-page-card"
                    style={{
                      position: "relative",
                      zIndex: activeDropdownId?.startsWith("design_") ? 100 : 5,
                      overflow: "visible",
                    }}
                  >
                    {/* Header */}
                    <div className="project-section-header">
                      <div className="project-section-title-wrap">
                        <div className="project-section-icon-box">
                          <Diamond size={22} />
                        </div>
                        <div>
                          <h2 className="project-section-title">
                            Design options for{" "}
                            <span style={{ color: "#ea580c" }}>
                              {activeRoom.roomTypeName || activeRoom.roomType}
                            </span>
                          </h2>
                          <p className="project-section-subtitle">
                            Choose the design options to import
                          </p>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn-outline-orange"
                        onClick={() => addDesign(activeRoom)}
                      >
                        <Plus size={16} strokeWidth={2.5} />
                        Add design options
                      </button>
                    </div>

                    {/* Design Option Cards */}
                    {activeRoomDesignOptions.length > 0 ? (
                      <div className="design-options-grid" style={{ overflow: "visible" }}>
                        {activeRoomDesignOptions
                          .map((l, index) => {
                            const isDraftItem = isDraftCard(l);
                            const isValuePrice = dataOfClient?.priceType === "value";
                            const designKey = `design_${l.id || l.ID || index}`;
                            const isDesignDropdownOpen = activeDropdownId === designKey;

                            return (
                              <div
                                key={l.id || l.ID || index}
                                className={`design-option-clean-card ${isDraftItem ? "is-draft" : ""} ${isDesignDropdownOpen ? "has-open-dropdown" : ""}`}
                                style={{
                                  position: "relative",
                                  zIndex: isDesignDropdownOpen ? 99999 : 1,
                                  overflow: "visible",
                                }}
                              >
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                  {isDraftItem ? (
                                    <span className="badge-draft-saved">Draft Saved Copy</span>
                                  ) : l.roomType === "ExtraItems" || l.roomType === "Other Works" ? (
                                    <span className="badge-new-price">Standard</span>
                                  ) : isValuePrice ? (
                                    <span className="badge-new-price">New price</span>
                                  ) : (
                                    <span className="badge-old-price">Old price</span>
                                  )}

                                  {dataOfClient.from !== 'sent' && (
                                    <div className="crm-custom-dropdown-container">
                                      <button
                                        type="button"
                                        className={`crm-dots-btn ${activeDropdownId === designKey ? "is-active" : ""}`}
                                        title="Options"
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setActiveDropdownId(prev => prev === designKey ? null : designKey);
                                        }}
                                      >
                                        <MoreVertical size={16} />
                                      </button>

                                      {activeDropdownId === designKey && (
                                        <div
                                          className="crm-custom-dropdown-menu"
                                          onMouseDown={(e) => e.stopPropagation()}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <button
                                            type="button"
                                            className="crm-dropdown-item"
                                            onClick={() => {
                                              setActiveDropdownId(null);
                                              renameDesignModalFun(l);
                                            }}
                                          >
                                            <Edit3 size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                            Rename
                                          </button>
                                          <button
                                            type="button"
                                            className="crm-dropdown-item"
                                            onClick={() => {
                                              setActiveDropdownId(null);
                                              duplicationDesign(l);
                                            }}
                                          >
                                            <Copy size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                            Duplicate
                                          </button>
                                          <button
                                            type="button"
                                            className="crm-dropdown-item"
                                            onClick={() => {
                                              setActiveDropdownId(null);
                                              viewDesign(l);
                                            }}
                                          >
                                            <Eye size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                            View
                                          </button>
                                          <button
                                            type="button"
                                            className="crm-dropdown-item"
                                            onClick={() => {
                                              setActiveDropdownId(null);
                                              editDesign(l);
                                            }}
                                          >
                                            <Pencil size={14} style={{ marginRight: "8px", color: "#64748b" }} />
                                            Edit
                                          </button>
                                          <div className="crm-dropdown-divider" />
                                          <button
                                            type="button"
                                            className="crm-dropdown-item text-danger"
                                            onClick={() => {
                                              setActiveDropdownId(null);
                                              deleteDocument(l);
                                            }}
                                          >
                                            <Trash2 size={14} style={{ marginRight: "8px", color: "#ef4444" }} />
                                            Delete
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>

                                <div className="design-card-name">
                                  {l.roomTypeDesign}
                                </div>

                                <div className="design-card-price">
                                  {"\u20B9"} {(Number(l.roomTypePrice) || 0).toLocaleString("en-IN")}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: "30px 20px", color: "#94a3b8", fontSize: "14px" }}>
                        No design options added yet for this room. Click <strong>+ Add design options</strong> above to create one.
                      </div>
                    )}
                  </div>
                )}

                {/* ── CARD 3: QUOTATIONS SECTION ── */}
                <div
                  className="project-page-card"
                  style={{
                    marginBottom: "24px",
                    position: "relative",
                    zIndex: 1,
                    overflow: "visible",
                  }}
                >
                  <div className="project-section-header">
                    <div>
                      <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#ea580c", margin: 0 }}>
                        Quotations
                      </h2>
                    </div>
                    <div>
                      <Button
                        className="btn-primary-orange"
                        onClick={() => navigation("/projects/view-rooms/add-quotation", { state: dataOfClient })}
                      >
                        <Plus size={16} strokeWidth={2.5} />
                        Add Quotations
                      </Button>
                    </div>
                  </div>

                  <div className="table-container">
                    <div className="tableScroll">
                      <Table responsive hover style={{ marginBottom: 0 }}>
                        <thead>
                          <tr className="table-warning" style={{ verticalAlign: "middle" }}>
                            <th style={{ width: "40px", textAlign: "center", padding: "12px 10px" }}>#</th>
                            <th style={{ minWidth: "150px", padding: "12px 12px" }}>Quote ID</th>
                            <th style={{ minWidth: "120px", padding: "12px 12px" }}>Name</th>
                            <th style={{ minWidth: "110px", padding: "12px 12px" }}>Create</th>
                            <th style={{ minWidth: "100px", textAlign: "center", padding: "12px 12px" }}>Status</th>
                            <th style={{ minWidth: "120px", padding: "12px 12px" }}>Total (Rs.)</th>
                            <th colSpan="4" style={{ textAlign: "center", padding: "12px 12px" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="table-light">
                          {status === "loading" ? (
                            <tr>
                              <td colSpan="10" style={{ textAlign: "center", padding: "30px" }}>
                                <Spinner animation="border" variant="primary" />
                              </td>
                            </tr>
                          ) : data?.quotes?.length > 0 ? (
                            data.quotes.map((e, i) => (
                              <tr key={i} style={{ verticalAlign: "middle" }}>
                                <td style={{ verticalAlign: "middle", textAlign: "center", fontWeight: "600", color: "#666", padding: "12px 10px" }}>{i + 1}</td>
                                <td style={{ verticalAlign: "middle", fontWeight: "600", color: "#1e293b", padding: "12px 12px", whiteSpace: "nowrap" }}>{e.ID}</td>
                                <td style={{ verticalAlign: "middle", color: "#475569", padding: "12px 12px" }}>{e.quotationName || "—"}</td>
                                <td style={{ verticalAlign: "middle", color: "#64748b", fontSize: "13px", padding: "12px 12px", whiteSpace: "nowrap" }}>{e.quotationDate}</td>
                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "12px 12px" }}>
                                  <span style={{
                                    backgroundColor: "#10b981",
                                    borderRadius: "12px",
                                    textAlign: "center",
                                    color: "#fff",
                                    padding: "3px 10px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    display: "inline-block"
                                  }}>
                                    Submitted
                                  </span>
                                </td>
                                <td style={{ verticalAlign: "middle", fontWeight: "700", color: "#ea580c", padding: "12px 12px", whiteSpace: "nowrap" }}>₹ {(Number(e.quotationPrice) || 0).toLocaleString("en-IN")}</td>
                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "10px 6px" }}><ViewProfile e={e} /></td>
                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "10px 6px" }}>
                                  <Link to="/QC-ClientPDFview" state={{ e, userDetailsLo }}>
                                    <button
                                      style={{
                                        backgroundColor: "#0284c7",
                                        border: "none",
                                        color: "#fff",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      QC-Quote
                                    </button>
                                  </Link>
                                </td>
                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "10px 6px" }}>
                                  <a
                                    href={`/project/${e.clientDetails?.id || dataOfClient?.id}/quotations/${e.ID}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <button
                                      style={{
                                        backgroundColor: "#334155",
                                        border: "none",
                                        color: "#fff",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      Open / Share
                                    </button>
                                  </a>
                                </td>
                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "10px 6px" }}>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      style={{
                                        backgroundColor: "#f1f5f9",
                                        color: "#334155",
                                        border: "1px solid #cbd5e1",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500"
                                      }}
                                    >
                                      Options
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu style={{ padding: "12px", minWidth: "160px" }}>
                                      {Object.entries(e.quotationpermission || {}).map(
                                        ([key, value]) => (
                                          <Form.Check
                                            key={key}
                                            type="checkbox"
                                            label={key}
                                            checked={value}
                                            style={{ marginBottom: "6px" }}
                                          />
                                        )
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
                                No Quotations Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '1rem',
                        marginTop: '16px',
                        paddingTop: '12px',
                        borderTop: '1px solid #f1f5f9'
                      }}>
                        <button className="buttonDesign" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                          Previous
                        </button>
                        <span>Page {currentPage}</span>
                        <button className="buttonDesign" onClick={() => setCurrentPage(prev => prev + 1)} disabled={!data?.hasNextPage}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Row className="addRow">
                <Col className="ggff">
                  <p style={{ fontSize: 36, fontFamily: 'Arial', fontWeight: 100 }}>You don't have any rooms yet</p>
                  <Button className="w-25" onClick={() => addRoom()}>Add room</Button>
                </Col>
              </Row>
            )}


            <Modal show={renameOn} onHide={handleRenameCloseOn}>
              <Modal.Body>
                <Form>
                  <Form.Control
                    type="text"
                    value={nameRoomTypeName}
                    onChange={(e) => { setNameRoomTypeName(e.target.value) }}
                    autoFocus
                  />
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button className='buttonDesign-Danger' onClick={() => handleRenameCloseOn()}>
                  Cancel
                </button>
                <button className='buttonDesign-Safe' onClick={() => handleRenameCom()}>Rename</button>
              </Modal.Footer>
            </Modal>

            <Modal show={renameDesignModal} onHide={handleRenameDesignCloseModal}>
              <Modal.Body>
                <Form>
                  <Form.Control
                    type="text"
                    value={newDesignTypeName}
                    onChange={(e) => { setNewDesignTypeName(e.target.value) }}
                    autoFocus
                  />
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button className='buttonDesign-Danger' onClick={() => handleRenameDesignCloseModal()}>
                  Cancel
                </button>
                <button className='buttonDesign-Safe' onClick={() => handleRenameDesignModal()}>Rename</button>
              </Modal.Footer>
            </Modal>


            <React.Fragment >
              {/* ── Assign User Dialog ── */}
              <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle style={{ fontSize: 16, fontWeight: 500, color: "#111", borderBottom: "0.5px solid #e5e7eb", padding: "16px 24px" }}>
                  Assign user
                </DialogTitle>
                <DialogContent style={{ padding: "24px" }}>
                  <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }}>Select a user to assign</p>
                  <Autocomplete
                    disablePortal options={userList}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: 300, marginBottom: 3 }}
                    value={selectedName}
                    onChange={(event, newValue) => setSelectedName(newValue)}
                    renderInput={(params) => <TextField {...params} label="Users" size="small" />}
                  />
                  <div style={{ borderTop: "0.5px solid #e5e7eb", paddingTop: 16, marginTop: 8 }}>
                    <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }}>Select quotation</p>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                      <thead>
                        <tr style={{ background: "#1a1128" }}>
                          {["", "#", "Name", "Date", "Status", "Total (Rs.)"].map((h, i) => (
                            <th key={i} style={{ padding: "9px 12px", textAlign: "left", color: "#fff", fontWeight: 500, fontSize: 11 }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {assignToDataDeepCopy.map((e, i) => (
                          <tr key={i} style={{ borderBottom: "0.5px solid #e5e7eb" }}>
                            <td style={{ padding: "10px 12px" }}>
                              <input type="radio" name="roomSelection" onChange={() => handleChange(e)} style={{ width: 16, height: 16, accentColor: "#ea6e2b" }} />
                            </td>
                            <td style={{ padding: "10px 12px", color: "#6b7280" }}>{i + 1}</td>
                            <td style={{ padding: "10px 12px", fontWeight: 500, color: "#6b7280" }}>{e.quotationName || "—"}</td>
                            <td style={{ padding: "10px 12px", color: "#6b7280" }}>{e.quotationDate}</td>
                            <td style={{ padding: "10px 12px", color: "#6b7280" }}>
                              <span style={{ background: "#eaf3de", color: "#3b6d11", borderRadius: 5, padding: "3px 8px", fontSize: 10, fontWeight: 500 }}>Submitted</span>
                            </td>
                            <td style={{ padding: "10px 12px", fontWeight: 500 }}>₹ {e.quotationPrice}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <TextField
                    fullWidth multiline rows={3} margin="normal"
                    label="Description" placeholder="Enter description here..."
                    variant="outlined" value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    size="small" style={{ marginTop: 16 }}
                  />
                  {assignLoader && (
                    <div style={{ marginTop: 20 }}>
                      <div
                        style={{
                          width: "100%",
                          height: 10,
                          background: "#e5e7eb",
                          borderRadius: 20,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: `${progress}%`,
                            height: "100%",
                            background: "#ea6e2b",
                            transition: "0.3s ease",
                          }}
                        />
                      </div>
                      <p
                        style={{
                          fontSize: 12,
                          marginTop: 8,
                          color: "#6b7280",
                          textAlign: "right",
                        }}
                      >
                        {progress}%
                      </p>
                    </div>
                  )}
                </DialogContent>
                <DialogActions style={{ borderTop: "0.5px solid #e5e7eb", padding: "12px 24px", gap: 8 }}>
                  <button onClick={handleClose} style={{ background: "#f3f4f6", color: "#374151", border: "0.5px solid #d1d5db", borderRadius: 7, padding: "7px 16px", fontSize: 13, cursor: "pointer" }}>Cancel</button>
                  <button
                    onClick={handleAssignProject}
                    disabled={assignLoader}
                    style={{
                      background: assignLoader ? "#f3a57b" : "#ea6e2b",
                      color: "#fff",
                      border: "none",
                      borderRadius: 7,
                      padding: "7px 16px",
                      fontSize: 13,
                      cursor: assignLoader ? "not-allowed" : "pointer",
                      minWidth: 120,
                    }}
                  >
                    {assignLoader ? `Assigning ${progress}%` : "Assign"}
                  </button>
                </DialogActions>
              </Dialog>
            </React.Fragment>


          </Row>

        </Col>
      </Row>



    </Container>
  );
}
export default ProjectView;